import * as React from 'react'

import { Button, ModalDialogType } from '@factorialco/deprecated-design-system'

import Dialog from 'modules/core/components/Modal/Dialog'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
interface Props {
  onSubmit: () => void
}

const EnableEditModal = ({ onSubmit }: Props) => {
  return (
    <div className={'PdfViewer_modalContainer'}>
      <Dialog
        type={ModalDialogType.Regular}
        title={i18n.t('documents.viewer.editModal.title')}
        description={i18n.t('documents.viewer.editModal.description')}
        onSubmit={onSubmit}
        footer={<Button submit>{i18n.t('documents.viewer.editModal.action')}</Button>}
        locked
      />
    </div>
  )
}

export default EnableEditModal
